import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (!_ctx.paymentMethodItem.visible)
    ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        "popper-class": "geo-payment-method-toggle__popover",
        width: "370",
        trigger: "hover"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_button, {
            text: "",
            type: "danger",
            class: "geo-payment-method-toggle__button",
            icon: _ctx.icons.QuestionFilled
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Unavailable ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["icon"])
        ]),
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("p", null, "Not visible in the cashier (part of a multimethod)", -1 /* CACHED */))
        ]),
        _: 1 /* STABLE */
      }))
    : (_openBlock(), _createBlock(_component_el_switch, {
        key: 1,
        modelValue: _ctx.paymentMethodItem[_ctx.geoPaymentMethodProperty],
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paymentMethodItem[_ctx.geoPaymentMethodProperty]) = $event)),
        disabled: _ctx.isPartialUpdateGlobalPaymentMethodDisallowed,
        onChange: _ctx.updateGeoPaymentMethod
      }, null, 8 /* PROPS */, ["modelValue", "disabled", "onChange"]))
}